import { useEffect, useRef } from 'react';
import Lottie from 'lottie-web';
import * as styles from './styles';
import * as LoadingAnimation from '@assets/animation/loading.json';

const Instruction = () => {
  const pendingAnimation = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (pendingAnimation.current) {
      Lottie.loadAnimation({
        container: pendingAnimation.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: LoadingAnimation
      });
    }
  }, [pendingAnimation]);

  return (
    <div css={styles.contentContainer}>
      <div css={styles.loadingAnimation} ref={pendingAnimation} />
      <p css={styles.title}>비대면 진료 연결중입니다.</p>
      <div css={styles.instructions}>
        <p css={styles.instruction}>1. 의사와 연결되면 화상 진료가 시작돼요.</p>
        <p css={styles.instruction}>2. 진료에 따라 처방전이 발급되지 않을 수 있어요.</p>
        <p css={styles.instruction}> 3. 진료가 끝나면 진료비를 결제해주세요.</p>
      </div>
    </div>
  );
};

export default Instruction;
